import React, { useEffect, useState } from 'react';
import { StyledAsyncSelect, StyledInputContainer } from 'components/inputs/Select/CategorySearchSelect/Styled';
import { alertErrorMessage } from 'utils/alerts';
import ClearInputButton from 'components/Button/ClearInputButton';
import { icons } from 'assets/icons/index'
import { NoSearchResultsPanelStyledDiv } from '../Styled';
import { Label } from 'components/Label';

type NewBeaconSearchFormTypes = {
  onSearch: (value: string) => Promise<any>;
};

export default function NewBeaconSearch(props: NewBeaconSearchFormTypes) {
  const [showMinimumCharactersError, setShowMinimumCharactersError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>()

  useEffect(() => {
    if (searchTerm === "") {
      onSearch('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm])

  const onSearch = (searchTerm: string) => {
    const termTrimmed = searchTerm.trim();
    setIsLoading(true);

    props.onSearch(termTrimmed)
      .then(() => setIsLoading(false))
      .catch((err) => {
        setIsLoading(false);
        alertErrorMessage(`Search Failed: ${err.message}`);
        console.error(err.message);
      });
  };

  function handleClearField() {
    setSearchTerm(undefined);
    onSearch('')
  }

  function handleInputChange(term: string, actionObj: any) {
    switch (actionObj.action) {
      case 'input-change':
        setSearchTerm(term);
        setShowMinimumCharactersError(false);

        break;
      case 'menu-close':
        setSearchTerm(searchTerm);
        break;
      case 'input-blur':
        setSearchTerm(searchTerm);
        break;
      default:
        break;
    }
  }

  function handleKeyPress(e: React.KeyboardEvent) {
    if (e.key === 'Enter' && searchTerm) {
      if (searchTerm.length < 3) {
        setShowMinimumCharactersError(true);
        return;
      }
      onSearch(searchTerm)
    }
  }

  return (
    <StyledInputContainer width={350}>
      <Label
        htmlFor="search-new-beacon-input"
        value={"Search for new beacons"}
        className="sr-only"
      />
      <StyledAsyncSelect
        id="search-new-beacon"
        inputId="search-new-beacon-input"
        isLoading={isLoading}
        placeholder="Search for beacon ID"
        onInputChange={handleInputChange}
        onKeyDown={(e: React.KeyboardEvent) => handleKeyPress(e)}
        inputValue={searchTerm}
        className="asyncSearch"
        classNamePrefix="asyncSearchPrefix"
        menuIsOpen={false}
      />
      {(searchTerm?.length || 0) > 0 && (
        <ClearInputButton onClick={handleClearField} searchInProgress={isLoading} />
      )}
      {showMinimumCharactersError &&
        <NoSearchResultsPanelStyledDiv>
          <icons.ErrorIcon aria-label="Error" />
          <span>Please enter at least 3 characters</span>
        </NoSearchResultsPanelStyledDiv>}
    </StyledInputContainer>
  );
}
